import gsap from "gsap";

export default class MemberDropdown {
    constructor(container = document) {
        this.container = container;
        this.handleClick = this.handleClick.bind(this);
        this.init();
    }

    init() {
        this.container.addEventListener('click', this.handleClick);
    }

    handleClick(e) {
        const btn = e.target.closest('.dropdown-toggle');
        if (!btn) return;

        // NOUVEAU : On remonte au parent global de la carte
        const parentItem = btn.closest('.item');
        if (!parentItem) return;

        // On cherche le contenu déroulant spécifique à cette carte
        const content = parentItem.querySelector('.item_content-dropdown');
        if (!content) return;

        const isOpen = btn.classList.contains('open');
        if (isOpen) {
            this.closeDropdown(btn, content);
        } else {
            this.openDropdown(btn, content);
        }
    }

    openDropdown(btn, content) {
        btn.classList.add('open');

        // On s'assure que le contenu ne déborde pas pendant l'animation
        gsap.set(content, { overflow: "hidden", display: "block" });

        // On calcule la vraie hauteur auto
        gsap.set(content, { height: "auto", opacity: 1 });
        const height = content.offsetHeight;

        // On lance l'animation
        gsap.fromTo(content,
            { height: 0, opacity: 0 },
            {
                height: height,
                opacity: 1,
                duration: 0.4,
                ease: "power2.out",
                onComplete: () => {
                    gsap.set(content, { height: "auto", overflow: "visible" });
                }
            }
        );
    }

    closeDropdown(btn, content) {
        btn.classList.remove('open');
        const currentHeight = content.offsetHeight;

        gsap.set(content, { height: currentHeight, opacity: 1, overflow: "hidden" });
        gsap.to(content, {
            height: 0,
            opacity: 0,
            duration: 0.5,
            ease: "power2.inOut",
            onComplete: () => {
                // gsap.set(content, { display: "none" });
            }
        });
    }
}